// Mapping from state codes to state names
export const STATE_CODE_TO_NAME: Record<string, string> = {
    'AL': 'Alabama', 'AK': 'Alaska', 'AZ': 'Arizona', 'AR': 'Arkansas',
    'CA': 'California', 'CO': 'Colorado', 'CT': 'Connecticut', 'DE': 'Delaware',
    'FL': 'Florida', 'GA': 'Georgia', 'HI': 'Hawaii', 'ID': 'Idaho',
    'IL': 'Illinois', 'IN': 'Indiana', 'IA': 'Iowa', 'KS': 'Kansas',
    'KY': 'Kentucky', 'LA': 'Louisiana', 'ME': 'Maine', 'MD': 'Maryland',
    'MA': 'Massachusetts', 'MI': 'Michigan', 'MN': 'Minnesota', 'MS': 'Mississippi',
    'MO': 'Missouri', 'MT': 'Montana', 'NE': 'Nebraska', 'NV': 'Nevada',
    'NH': 'New Hampshire', 'NJ': 'New Jersey', 'NM': 'New Mexico', 'NY': 'New York',
    'NC': 'North Carolina', 'ND': 'North Dakota', 'OH': 'Ohio', 'OK': 'Oklahoma',
    'OR': 'Oregon', 'PA': 'Pennsylvania', 'RI': 'Rhode Island', 'SC': 'South Carolina',
    'SD': 'South Dakota', 'TN': 'Tennessee', 'TX': 'Texas', 'UT': 'Utah',
    'VT': 'Vermont', 'VA': 'Virginia', 'WA': 'Washington', 'WV': 'West Virginia',
    'WI': 'Wisconsin', 'WY': 'Wyoming', 'DC': 'District of Columbia', 'NATIONAL': 'National'
};

// Mapping from LOB values to display names
export const LOB_VALUE_TO_NAME: Record<string, string> = {
    'commercial': 'Commercial',
    'medicare': 'Medicare',
    'medicare_advantage': 'Medicare Advantage',
    'medicaid': 'Medicaid',
    'exchange_qhp': 'Qualified Health Plan',
    'other': 'Other'
};

export type ContactSupportFormType = {
    patientName: string;
    mrn: string;
    surgeryDate?: string;
    claimNumber?: string;
    denialType?: string;
    subject?: string;
    comment?: string;
  }

  export const CONTACT_SUPPORT_PURPOSE_TYPES = {
    PRESERVICE_REVIEW: "Preservice Review",
    DENIAL_MANAGEMENT: "Denial",
    SUPPORT: "Support",
  };

  export const CONTACT_SUPPORT_FORM_FIELD_MAX_LENGTH = {
    patientName: 255,
    mrn: 100,
    claimNumber: 100,
    subject: 255,
    comment: 3000,
  };

  export const CONTACT_SUPPORT_ATTACHMENT_LIMITS = {
    maxFiles: 3,
    maxFileSizeMb: 25,
    allowedExtensions: ['.pdf', '.png', '.jpg', '.jpeg', '.csv', '.docx'],
    acceptLabel: 'PDF, PNG, JPG, CSV or DOCX',
  };

  // A ticket reply's files go to Zammad in one base64'd call, which the backend
  // caps at ~7.5 MB of files in total (ZAMMAD_MAX_ATTACHMENT_BYTES).
  export const TICKET_REPLY_ATTACHMENT_LIMITS = {
    maxFiles: 3,
    maxTotalMb: 7.5,
    allowedExtensions: CONTACT_SUPPORT_ATTACHMENT_LIMITS.allowedExtensions,
    acceptLabel: CONTACT_SUPPORT_ATTACHMENT_LIMITS.acceptLabel,
  };

  // Hard cap on chat message length: keeps request payloads reasonable and
  // avoids excessive token usage on the backend.
  export const CHAT_INPUT_MAX_CHARS = 10000;

  // Pasting more than this many characters at once attaches the content as a
  // .txt file instead of dumping it into the message, mirroring ChatGPT/Claude.
  export const CHAT_PASTE_AS_FILE_THRESHOLD = 4000;
  
  const DENIAL_TYPE_LABELS = [
    "Authorization Issue",
    "Clinical/Medical Necessity",
    "Coding",
    "Contract",
    "Discharge Related",
    "Does Not Meet or Incorrect Criteria",
    "DRG Related",
    "Insufficient Information",
    "Insufficient Notification",
    "Not Covered",
    "Other or Unknown",
    "Readmission",
    "Unjustified Denial",
  ] as const;

  export const DENIAL_TYPE_OPTIONS = DENIAL_TYPE_LABELS.map((label) => ({
    value: label,
    label,
  }));
